import { useMemo } from 'react';
import Select from 'react-select';
import type { EngagementFilter } from '@trinity/chat';
import { useTheme } from '@trinity/chat-components/components/Theme';
import * as Presentation from './Presentation';

type Props = {
  value: EngagementFilter.Item | undefined;
  onChange: (value: EngagementFilter.Item) => void;
};
//This is a select filter for chat for engagement types proactive, reactive, and all which are 
export function Engagement({ value, onChange }: Props) {
  const theme = useTheme();

  const selectStyles = useMemo(() => Presentation.buildSelectStyles(theme), [theme]);
  const selectTheme = useMemo(() => Presentation.buildSelectTheme(theme), [theme]);

  const options = [
    { id: 'all', name: 'All (Reactive and Proactive)' },
    { id: 'proactive', name: 'Proactive' },
    { id: 'reactive', name: 'Reactive' },
  ] as EngagementFilter.Item[];

  //default is also set here in order of options
  const selected = options.find(opt => opt.id === value?.id) ?? options[0];

  const handleChange = (option: EngagementFilter.Item | null) => {
    if (option) {
      onChange(option);
    }
  };

  return (
    <Presentation.Row>
      <Presentation.Label>Engagement</Presentation.Label>
      <Presentation.Value>
        <Select<EngagementFilter.Item, false>
          styles={selectStyles}
          theme={selectTheme}
          value={selected}
          isMulti={false}
          isSearchable={false}
          isClearable={false}
          options={options}
          getOptionLabel={o => o.name}
          getOptionValue={o => `${o.id}`}
          onChange={opt => handleChange(opt)}
          menuPlacement="auto"
        />
      </Presentation.Value>
    </Presentation.Row>
  );
}